<template>
    <div class="component-playback">
      <div class="playback-content">
        <div style="width: 100%" id="playback-video-h5">
          <play-show :data="currentData" type="h5" v-if="showVideo"></play-show>
          <div class="playback-none" v-else></div>
        </div>
        <div style="width: 100%;height: 320px;margin-top: 16px">
          <play-tablist type="h5" :data="props.data" @playVideo="playVideo"></play-tablist>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { nextTick, ref, onMounted } from 'vue'
  import PlayShow from './play-show.vue'
  import PlayTablist from './play-tablist.vue'

  const props = defineProps({
  data: {
    type: Number,
    default: 2025
  }
})

  onMounted(() => {
})
  
  let showVideo = ref(false)
  
  const currentData = ref({})
  const playVideo = (data) => {
    currentData.value = data
    showVideo.value = false
    nextTick(() => {
      showVideo.value = true
    })
  }
  
  
  </script>
  
  <style lang="scss" scoped>
  .component-playback {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: -20px;
    padding: 0 20px;
    .playback-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      .playback-none{
        width: 100%;
        height: 100%;
        background: #ffffff;
        border-radius: 16px;
      }
    }
  }
  </style>
   